import React, { useState, useRef, useEffect } from "react";
import infoIcon from "../../../../assets/design-revamp-company/add-edit/infoIcon.svg";
import "./index.css";
import TipBox from "../../../../components/TipBox";

const useOutsideClick = (callback) => {
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [callback]);

  return ref;
};

const InfoIconFacility = ({ text, customTextColor }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const tooltipRef = useOutsideClick(() => setIsTooltipVisible(false));

  return (
    <TipBox title={"Info"} message={text}>
      <div className="info-icon-container" ref={tooltipRef}>
        <img
          src={infoIcon}
          alt="Info Icon"
          className="info-icon"
          onClick={() => setIsTooltipVisible(!isTooltipVisible)}
        />
      </div>
    </TipBox>
  );
};

export default InfoIconFacility;
